import { Col, Flex, Image, Layout, Row, Spacing } from "@p0security/ui";
import React, { CSSProperties } from "react";

import { Footer } from "./App/Footer";

export const Splash: React.FC<
  React.PropsWithChildren<{
    overrideColumn?: boolean;
    showLogo?: boolean;
    rowStyleOverride?: CSSProperties;
    onNext?: () => void;
  }>
> = ({ children, overrideColumn, rowStyleOverride, showLogo = true }) => {
  return (
    <Layout className="w-full overflow-y-auto py-5">
      <Flex align="center" flex={1} justify="center">
        <div className="flex flex-col justify-center w-full">
          {showLogo && (
            <Spacing asChild mb="25px">
              <Flex justify="center">
                <Image
                  preview={false}
                  src={"/p0-logomark-dark.svg"}
                  alt="P0"
                  width={200}
                />
              </Flex>
            </Spacing>
          )}
          <Row
            justify="center"
            align="top"
            /* eslint-disable-line react/forbid-component-props */ style={{
              flex: 1,
              ...rowStyleOverride,
            }}
            gutter={[24, 24]}
          >
            {overrideColumn ? (
              children
            ) : (
              <Col xs={20} md={12} lg={10} xl={8}>
                {children}
              </Col>
            )}
          </Row>
        </div>
      </Flex>
      <Footer />
    </Layout>
  );
};
